import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { superAdminKeys } from './superAdminKeys';

export interface BulkUpdateUsersWeeklyReportParams {
  userIds: number[];
  weeklyReportEnabled: boolean;
}

export const bulkUpdateUsersWeeklyReport = async ({
  userIds,
  weeklyReportEnabled,
}: BulkUpdateUsersWeeklyReportParams) => {
  const response = await EXPRESS_API.patch(`/superadmin/users/weekly-report`, {
    userIds,
    weeklyReportEnabled,
  });
  return response.data;
};

export const useBulkUpdateUsersWeeklyReportMutation = (
  closeModal?: () => void
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation(bulkUpdateUsersWeeklyReport, {
    onSuccess: (_, variables: BulkUpdateUsersWeeklyReportParams) => {
      queryClient.invalidateQueries([
        superAdminKeys.all_users_for_superadmin(),
      ]);
      if (closeModal) {
        closeModal();
      }
      const count = variables.userIds.length;
      successToast({
        title: t(
          'Report settings updated successfully for {{count}} user{{suffix}}',
          {
            count,
            suffix: count === 1 ? '' : 's',
          }
        ),
      });
    },
    onError: () => {
      if (closeModal) {
        closeModal();
      }
      errorToast({
        title: t(
          'There was an error updating report settings. Please try again.'
        ),
      });
    },
  });
};
